import React from "react";

const ResetPasswordPage = (props) => {
  return <h2>hello</h2>;
};

export default ResetPasswordPage;
